import { render, staticRenderFns } from "./MyApplyForAssessment.vue?vue&type=template&id=078d8231&scoped=true&"
import script from "./MyApplyForAssessment.vue?vue&type=script&lang=js&"
export * from "./MyApplyForAssessment.vue?vue&type=script&lang=js&"
import style0 from "./MyApplyForAssessment.vue?vue&type=style&index=0&id=078d8231&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078d8231",
  null
  
)

export default component.exports